// extracted by mini-css-extract-plugin
module.exports = {"ball-info":"ijhwd","boxscore":"hDuEv","Extras":"gtuFQ","wicket":"oTyO8","no-runs":"pvPMU","six":"OuWFU","four":"RpuWw"};